import axios from "axios";
import { CONFIG } from "../../config";

// POST /api/auth/reset-password - new V2-style Forgot Password endpoint. Sends only the
// reset token (from the emailed link) and the new password - never a userId/email, unlike
// the legacy passwordRecovery()/change-password call this replaces for this flow.
export const resetPasswordService = async (token, password) => {
	try {
		const response = await axios.post(`${CONFIG.AUTHURL}/api/auth/reset-password`, {
			token,
			password,
		});
		return response.data;
	} catch (error) {
		console.log(error);
		return { status: "unsuccessfull", message: "Something went wrong" };
	}
};
